module.exports = __webpack_public_path__ + "static/media/icon-campaigns-blue.f4be76df.svg";